import { type ControlProps, type Option, ControlType, FieldType } from '../../../Form';
import { OPTIONS_SORT, parseAddLabel, sortOptionsByAlphabetic, sortOptionsByNum } from '../utils';

type GetListboxContainer = {
  fieldName: string;
  containerTitle: string;
  containerName: string;
  options: Option[];
  value: (number | string)[];
  clearAll: string;
  fieldClassName: string;
  hide?: boolean;
  isMobile?: boolean;
  isSidebar?: boolean;
  isHorizontal?: boolean;
  hasTwoColumns?: boolean;
  optionsSort?: OPTIONS_SORT;
};

const getListboxContainer = ({
  fieldName,
  containerName,
  containerTitle,
  options,
  value,
  clearAll,
  fieldClassName,
  hide,
  isMobile,
  isSidebar,
  isHorizontal,
  hasTwoColumns,
  optionsSort = OPTIONS_SORT.NUM,
}: GetListboxContainer): ControlProps => {
  const parsedOptions = options.map((option) => ({
    ...option,
    ...(option.addLabel
      ? {
          addLabel: parseAddLabel({
            withBrackets: !isMobile && !isSidebar,
            count: option.addLabel,
          }),
        }
      : {}),
  }));

  const sortedOptions = (): Option[] => {
    if (optionsSort === OPTIONS_SORT.NUM) return sortOptionsByNum(sortOptionsByAlphabetic(parsedOptions));
    if (optionsSort === OPTIONS_SORT.ALPHABET) return sortOptionsByAlphabetic(parsedOptions);
    return parsedOptions;
  };

  return {
    control: ControlType.CONTAINER,
    name: containerName,
    top: { text: containerTitle },
    controls: [
      {
        control: ControlType.LISTBOX,
        type: FieldType.MULTILISTBOX,
        name: fieldName,
        label: { text: '' },
        className: fieldClassName,
        options: sortedOptions(),
        value,
        default: [],
        expanded: true,
        minEl: 2,
        // isValid: true,
        ...((!isMobile && !isSidebar && !isHorizontal) || hasTwoColumns ? { columns: 2 } : {}),
        ...(isMobile || isSidebar ? { iconOnTheRight: true } : {}),
      },
    ],
    controlProps: {
      clearAll,
    },
    hide,
  };
};

export default getListboxContainer;
